/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { CertService } from "../../../shared/base/cert.service";

/**
 * For html app, just jump to cert accept page.
 */
export class CertHTML5Service extends CertService {
   public tryToShowCertPage = (url) => {
      window.location.href = url;
   };
}
